module.exports = __webpack_public_path__ + "img/bg_aviodPhoney_01.03646867.jpg";